
import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { CircleDollarSign, Wallet } from "lucide-react";
import { UseFormReturn } from "react-hook-form";
import { ClienteFormValues } from "../types";

interface ConsumoSectionProps {
  form: UseFormReturn<ClienteFormValues>;
}

const ConsumoSection = ({ form }: ConsumoSectionProps) => {
  return (
    <div className="bg-white p-5 rounded-lg shadow-sm border border-amber-50">
      <h3 className="text-lg font-medium text-amber-800 mb-4 flex items-center">
        <Wallet className="h-5 w-5 mr-2 text-amber-600" />
        Dados de Consumo
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField
          control={form.control}
          name="gastoEnergia"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-gray-700">Gasto com Energia (R$/mês)</FormLabel>
              <FormControl>
                <div className="relative">
                  <CircleDollarSign className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
                  <Input 
                    type="number" 
                    step="0.01" 
                    min="0"
                    placeholder="0.00" 
                    className="pl-10 focus:border-amber-500 focus:ring-amber-100"
                    {...field}
                    onChange={(e) => field.onChange(parseFloat(e.target.value) || 0)}
                  />
                </div>
              </FormControl>
              <FormMessage className="text-xs mt-1" />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="tarifaEnergia"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-gray-700">Tarifa de Energia (R$/kWh)</FormLabel>
              <FormControl>
                <div className="relative">
                  <CircleDollarSign className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
                  <Input 
                    type="number" 
                    step="0.001" 
                    min="0"
                    placeholder="0.000" 
                    className="pl-10 focus:border-amber-500 focus:ring-amber-100"
                    {...field}
                    onChange={(e) => field.onChange(parseFloat(e.target.value) || 0)}
                  />
                </div>
              </FormControl>
              <FormMessage className="text-xs mt-1" />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};

export default ConsumoSection;
